import { render, staticRenderFns } from "./SuppliesCreate.vue?vue&type=template&id=88fde906&scoped=true"
import script from "./SuppliesCreate.vue?vue&type=script&lang=js"
export * from "./SuppliesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fde906",
  null
  
)

export default component.exports